var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo } from 'react';
import styled from 'styled-components';
import { useAppDispatch, useAppSelector, useQuery } from '../../hooks';
import * as api from '../../api/matches';
import { selectMatchState, setMatch, setMatchState } from '../../store/match';
import { useErrorHandler } from '../../hooks/useErrorHandler';
import { PlayerActions } from '../../components/organisms/PlayerActions/PlayerActions';
const Wrapper = styled.div `
  display: flex;
  flex-direction: column;
`;
const PageContainer = styled(Wrapper) `
  flex-direction: column;
`;
export function MatchPlayerActions() {
    const { param: matchId } = useQuery('matchId');
    const { errorHandler } = useErrorHandler();
    const dispatch = useAppDispatch();
    const matchState = useAppSelector(selectMatchState);
    const players = useMemo(() => matchState === null || matchState === void 0 ? void 0 : matchState.players, [matchState]);
    const getMatch = () => __awaiter(this, void 0, void 0, function* () {
        if (!matchId)
            return;
        try {
            const result = yield api.loadMatch(matchId);
            // console.log('MatchConfig getMatch', result)
            dispatch(setMatch(result));
        }
        catch (e) {
            console.error('MatchConfig getMatch error', e.response);
            errorHandler(e);
        }
    });
    const getMatchState = () => __awaiter(this, void 0, void 0, function* () {
        if (!matchId)
            return;
        try {
            const result = yield api.getMatchState(matchId);
            // console.log('Match getMatchState', result)
            dispatch(setMatchState(result));
            // dividePlayers(result.players)
        }
        catch (e) {
            console.error('Match getMatchState', e.response);
        }
    });
    useEffect(() => {
        getMatch();
        getMatchState();
    }, [matchId]);
    return (_jsx(PageContainer, { children: _jsx(PlayerActions, { players: players || [], matchId: matchId || '', reload: () => getMatchState() }) }));
}
